<div mat-dialog-title class="dialog-header">
   <h3 class="dialog-title">Allow IP Address</h3>
   <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
</div>
<form [formGroup]="form" (ngSubmit)="onAllow()">
   <mat-dialog-content>
      <mat-form-field class="flex-full">
         <mat-label>IP Address</mat-label>
         <input matInput autocomplete="off" type="text" formControlName="ipAddress" id="allow-ip-address" />
      </mat-form-field>
      <mat-form-field class="flex-full">
         <mat-label>Customer Account</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="accountSelect"
            ndtAccountSelect
            formControlName="account"
            id="allow-ip-account"
            required
         />
         <ndt-account-select #accountSelect></ndt-account-select>
         @if (form.get('account')?.hasError('required')) {
         <mat-error>Customer Account is required.</mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-full">
         <mat-label>qManage Ticket</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="qManageTicketId"
            id="allow-ip-qmanage-ticket"
            required
         />
         @if (form.get('qManageTicketId')?.hasError('required')) {
         <mat-error>qManage Ticket is required.</mat-error>
         } @if (form.get('qManageTicketId')?.hasError('maxlength')) {
         <mat-error>qManage Ticket is limited to 20 characters.</mat-error>
         }
      </mat-form-field>
   </mat-dialog-content>
   <mat-dialog-actions>
      <button type="submit" title="Allow" mat-raised-button [disabled]="form.invalid">Allow</button>
   </mat-dialog-actions>
</form>
